import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'app-ellipses-n-chars',
  templateUrl: './ellipses-n-chars.component.html',
  styleUrls: ['./ellipses-n-chars.component.scss'],
  standalone: false
})
export class EllipsesNCharsComponent implements OnChanges {

  private readonly MIN_CHARS = 1;

  @Input() nChars = 50;
  @Input() text: string;
  @Input() textHiddenClass: string | string[] | Set<string> | {
    [klass: string]: any;
  };
  @Input() textUnhiddenClass: string | string[] | Set<string> | {
    [klass: string]: any;
  };
  @Input() showLessClass: string | string[] | Set<string> | {
    [klass: string]: any;
  };
  @Input() hideButtons = false;

  showEllipsis = true;
  abbreviatedText: string;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      if (changes.nChars && this.nChars < this.MIN_CHARS) {
        throw new Error('nChars must be greater than or equal to ' + this.MIN_CHARS);
      }

      if (changes.text) {
        const abbreviate = this.text && this.text.length > this.nChars;
        if (changes.text.firstChange) {
          this.showEllipsis = abbreviate;
          this.hideButtons = !abbreviate;
        }
        this.abbreviatedText = abbreviate ? this.text.substring(0, this.nChars) : this.text;
      }
    }
  }

  setShowEllipsis(show: boolean, event: MouseEvent): void {
    event.stopPropagation();
    this.showEllipsis = show;
  }
}
